import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { useHistory } from 'react-router-dom'
import { TwitterTimelineEmbed } from 'react-twitter-embed'
import styled from 'styled-components'
import RouterMetaTags from '../../../components/molecules/RouterMetaTags'
import { Routes } from '../../../consts'
import { title1, title2, title3, title4, subtitle1, subtitle2, subtitle4 } from '../../../consts/Site'
import { customTheme } from '../../../libraries/MaterialUI'
import { useSubmitModelDialog } from '../../molecules/SubmitModelDialog/hooks'
import { RecentlyList } from './List'

// const LogoImage = styled.img`
//   width: 100%;
//   max-width: 200px;
// `

const TopImage = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 300px;
`

const FirstImpressionButton = styled(Button)`
  margin: ${customTheme.spacing(1, 1)} !important;
  min-width: 250px;
  font-size: 17px;
  font-weight: bold;
`

const FirstImpressionButtonArea = styled(Box)`
  text-align: center;
  margin: ${customTheme.spacing(3, 0, 3, 0)};
`

const Component = () => {
  const submitModelDialog = useSubmitModelDialog()
  const history = useHistory()
  return (
    <>
      <RouterMetaTags route={Routes.Home} />
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6} md={6} lg={7}>
          <Typography variant="h1" style={{ marginTop: '32px' }}>
            {title1}
          </Typography>
          <Typography variant="subtitle1" component="p" style={{ marginTop: '32px' }}>
            {subtitle1}
          </Typography>
          <FirstImpressionButtonArea>
            <FirstImpressionButton
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                history.push(Routes.Search.path)
              }}
            >
              Get started
            </FirstImpressionButton>
          </FirstImpressionButtonArea>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={5} style={{ textAlign: 'center', marginTop: '20px' }}>
          <TopImage alt="top_image_1" src="/images/top_image_1.png" />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6} md={6} lg={7}>
          <Typography variant="h1" style={{ marginTop: '32px' }}>
            {title2}
          </Typography>
          <Typography variant="subtitle1" component="p" style={{ marginTop: '32px' }}>
            {subtitle2}
          </Typography>
          <FirstImpressionButtonArea>
            <FirstImpressionButton
              variant="contained"
              color="primary"
              size="large"
              onClick={() => {
                submitModelDialog.handle.handleResetState()
                submitModelDialog.handle.handleOpen()
              }}
            >
              Add new CPSY paper
            </FirstImpressionButton>
          </FirstImpressionButtonArea>
        </Grid>
        <Grid item xs={6} sm={6} md={6} lg={5} style={{ textAlign: 'center', marginTop: '20px' }}>
          <TopImage alt="top_image_2" src="/images/top_image_2.png" />
        </Grid>
      </Grid>

      <Box>
        <Typography variant="h1" style={{ marginTop: '32px' }}>
          {title4}
        </Typography>
        <Typography variant="subtitle1" component="p" style={{ marginTop: '32px' }}>
          {subtitle4}
          <Link
            style={{ cursor: 'pointer' }}
            onClick={() => {
              history.push(Routes.Help.path)
            }}
          >
            {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
            {'Please check "Citing CPSYMAP Rules".'}
          </Link>
        </Typography>
      </Box>

      <Grid container spacing={3} style={{ marginTop: '20px' }}>
        <Grid item xs={7} sm={7} md={8}>
          <Typography variant="h1" style={{ marginTop: '32px' }} gutterBottom>
            {title3}
          </Typography>
          <Box style={{ overflow: 'scroll', overflowX: 'hidden', height: 600 }}>
            <RecentlyList />
          </Box>
        </Grid>
        <Grid item xs={5} sm={5} md={4}>
          <Box paddingTop={3}>
            <TwitterTimelineEmbed sourceType="profile" screenName="CPSYMAP" options={{ height: 600 }} />
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default Component
